<template>
  <div class="box">
    <div style="margin-bottom: 1.5rem;">
      #{{ $t("support_ticket.user_type." + reply.user_type) }}
    </div>

    <div class="level" style="margin-bottom: 1rem;">
      <div class="level-left">
        <user-tile :user="reply.user"></user-tile>
      </div>

      <div class="level-right">
        {{ reply.created_at }}
      </div>
    </div>

    <div style="margin-bottom: 1rem;">
      {{ reply.body }}
    </div>

    <div v-if="reply.attachments && reply.attachments.length > 0">
      <ul>
        <li v-for="attachment in reply.attachments" :key="attachment.id">
          <a
            :href="
              `/api/support/tickets/${$route.params.id}/replies/${
                reply.id
              }/attachments/${attachment}`
            "
            target="_blank"
          >
            {{ attachment }}
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: ["reply"]
};
</script>
